import Container, { InfoPannelType } from "../Container";
import SimpleIndicator, {
  SimpleIndicatorStyle,
} from "../../designSystem/SimpleIndicator";
import { ValidityFormValues } from "./ValidityForm";
import ValidityformRecap from "./ValidityFormRecap";

export interface MembershipOfferProps {
  className?: string;
  name: string;
  price: number;
  period: [Date, Date];
  validityFormValues: ValidityFormValues;
  resetValidityFormValues?: () => void;
}

const MembershipOffer = (props: MembershipOfferProps) => {
    const periodStr: string = `${props.period[0].toLocaleDateString('fr-FR')} - ${props.period[1].toLocaleDateString('fr-FR')}`
    return (
        <Container
            className={`${props.className ? props.className : ""} flex flex-col`}
            infoPanel={{
                message: "Vous êtes éligible à la souscription en ligne",
                type: InfoPannelType.SUCCESS,
            }}
        >
            <div className={"flex flex-col gap-y-4"}>
                <div className={"flex flex-wrap gap-y-4 gap-x-8 lg:justify-between"}>
                    <SimpleIndicator style={SimpleIndicatorStyle.BIG_VALUE} title={"Type de licence"} value={props.name} />
                    <SimpleIndicator style={SimpleIndicatorStyle.BIG_VALUE} title={"Montant"} value={props.price + " €"} />
                    <SimpleIndicator
                        style={SimpleIndicatorStyle.BIG_VALUE}
                        title={"Validité"}
                        value={<span className={"text-lg"}>{periodStr}</span>} />
                </div>
                <ValidityformRecap validityFormValues={props.validityFormValues} modify={props.resetValidityFormValues} />
            </div>
        </Container>
    );
}

export default  MembershipOffer;